import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";

@Component({
  selector: 'app-penalidade-list',
  templateUrl: './penalidade-list.component.html',
  styleUrls: ['./penalidade-list.component.css']
})
export class PenalidadeListComponent extends AppComponent implements OnInit {
	penalidades: any[];

	ngOnInit() {
        if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
		else
			this.penalidadeService.get().then(resp => this.penalidades = resp);
	}
}



// WEBPACK FOOTER //
// ./src/app/penalidade-list/penalidade-list.component.ts